import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/hospital-bed";
const API_PATH_SERVICE = ConstantList.API_EN_POINT + "/hospital-bed-hc-service";

export const getAllHospitalBed = () => axios.get(API_PATH + "/get-all");

export const pagingHospitalBed = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getHospitalBedById = (hospitalBedId) => axios.get(API_PATH + "/get-by-id/" + hospitalBedId);

export const saveOrUpdateHospitalBed = hospitalBed => axios.post(API_PATH + '/save', hospitalBed);

export const deleteHospitalBed = hospitalBedId => axios.delete(API_PATH + '/mark-delete/' + hospitalBedId);
export const pagingHospitalBedHCService = (searchObject) => axios.post(API_PATH_SERVICE + "/search-by-page", searchObject);
//dich vu giuong theo giuong
export const getListHospitalBedService = (hospitalBedId) => axios.post(API_PATH_SERVICE + "/get-list-hospital-bed-service", hospitalBedId);
// 
export const pagingHospitalBedService = (hospitalBedId) => axios.post(API_PATH_SERVICE + "/search-by-page", hospitalBedId);
//update status bed
export const updateStatusBed = (searchObject) => axios.post(API_PATH + "/update-status-bed", searchObject);

export const getListHospitalBed = (searchObject) => axios.post(API_PATH + "/get-list-hospital-bed", searchObject);

